module.exports = __webpack_public_path__ + "img/货源车源左侧.6bebf574.png";